import { render, staticRenderFns } from "./ContinueQuestionnaireModal.vue?vue&type=template&id=36d06b96&scoped=true"
import script from "./ContinueQuestionnaireModal.vue?vue&type=script&lang=js"
export * from "./ContinueQuestionnaireModal.vue?vue&type=script&lang=js"
import style0 from "./ContinueQuestionnaireModal.vue?vue&type=style&index=0&id=36d06b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d06b96",
  null
  
)

export default component.exports